export const AVAILABLELANGUAGES = [
  {
    code: 'en',
    name: 'English',
    icon: './assets/icon/flags/us.svg',
    selected: true,
    value: 0,
  },
  {
    code: 'es',
    name: 'Spanish',
    icon: './assets/icon/flags/cr.svg',
    selected: false,
    value: 1,
  },
];

export const AVAILABLELANGUAGES_ES = [
  {
    code: 'en',
    name: 'Inglés',
    icon: './assets/icon/flags/us.svg',
    selected: false,
    value: 0,
  },
  {
    code: 'es',
    name: 'Español',
    icon: './assets/icon/flags/cr.svg',
    selected: true,
    value: 1,
  },
];

export const objLangs = {
  es: AVAILABLELANGUAGES_ES,
  en: AVAILABLELANGUAGES,
};

export const DEFAULTLANGUAGE = 'es';

export const SYSOPTIONS = {
  systemLanguage: DEFAULTLANGUAGE,
};
